import React from 'react';

const items = [
  {
    icon: (
      <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2.2">
        <path d="M13 2 5 13h6l-1 9 9-12h-6l0-8Z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Fast Reimbursements',
    text: 'Personal spend reimbursed within a maximum of 30 days with fully tracked payout status for every claim.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2.2">
        <rect x="7" y="2.5" width="10" height="19" rx="2" />
        <circle cx="12" cy="18.4" r="0.9" />
      </svg>
    ),
    title: 'Easy Mobile App',
    text: "Plan trips, make UPI payments, and manage expenses seamlessly in one app—with zero receipts and real-time validation built in."
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2.2">
        <circle cx="12" cy="12" r="8.5" />
        <path d="M15.8 8.2 13.4 13.4 8.2 15.8l2.4-5.2 5.2-2.4Z" />
      </svg>
    ),
    title: 'Direct Booking',
    text: 'Book flights and hotels directly in the platform with corporate rates. No need to look elsewhere for the best deals.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2.2">
        <path d="M12 3 5.5 5.8v6c0 4.3 2.8 7.6 6.5 9.2 3.7-1.6 6.5-4.9 6.5-9.2v-6L12 3Z" />
        <path d="m9.5 12 1.8 1.8L15 10" />
      </svg>
    ),
    title: 'Built For India',
    text: 'Pay seamlessly anywhere using UPI—from local taxis to business dinners—with full compliance and real-time validation built in.'
  }
];

const EmployeeExperienceSection: React.FC = () => {
  return (
    <section className="bg-appbg px-6 py-16 lg:px-20">
      <div className="mx-auto max-w-[1728px]">
        <div className="rounded-[20px] border border-line bg-card p-6 sm:p-8 lg:p-10">
          <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
            <div>
              <p className="text-[14px] font-bold tracking-[0.08em] text-primary-600">EMPLOYEE EXPERIENCE</p>
              <h2 className="mt-5 max-w-[620px] text-[20px] font-bold leading-[1.08] tracking-[-0.03em] text-primary-800 lg:text-[44px]">
                Travel without the administrative burden.
              </h2>
              <p className="mt-10 max-w-[640px] text-[16px] leading-[1.45] text-muted lg:text-[18px]">
                We believe business travel should be an inspiration, not a chore. Our platform is designed to
                prioritize the traveler&apos;s time and peace of mind.
              </p>
            </div>

            <div className="space-y-16 pt-14">
              {[items[0], items[2]].map((item) => (
                <article key={item.title}>
                  <span className="flex h-20 w-20 items-center justify-center rounded-[22px] bg-primary-100 text-primary-600">
                    {item.icon}
                  </span>
                  <h3 className="mt-6 text-[28px] font-bold tracking-[-0.02em] text-primary-800">{item.title}</h3>
                  <p className="mt-3 text-[16px] leading-[1.45] text-muted">{item.text}</p>
                </article>
              ))}
            </div>

            <div className="space-y-16 pt-8 lg:-mt-2">
              {[items[1], items[3]].map((item) => (
                <article key={item.title}>
                  <span className="flex h-20 w-20 items-center justify-center rounded-[22px] bg-primary-100 text-primary-600">
                    {item.icon}
                  </span>
                  <h3 className="mt-6 text-[28px] font-bold tracking-[-0.02em] text-primary-800">{item.title}</h3>
                  <p className="mt-3 text-[16px] leading-[1.45] text-muted">{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmployeeExperienceSection;
